import { FC } from "react";
import classNames from "classnames";
import { LayoutProps, HeaderProps } from "./interface";

import styles from "./Layout.module.scss";

export const Layout: FC<LayoutProps> = ({ type = "usual", children }) => {
  return (
    <div
      className={classNames(styles.Layout, {
        [styles.white]: type === "white",
      })}
    >
      {children}
    </div>
  );
};

export const Header: FC<HeaderProps> = ({
  loading,
  direction = "row",
  align = "start",
  children,
}) => {
  return (
    <div
      className={classNames(
        styles.LayoutHeader,
        styles[`LayoutHeader_${align}`],
        styles[`LayoutHeader_${direction}`],
        {
          [`LayoutHeader_loading`]: loading,
        },
      )}
    >
      {children}
    </div>
  );
};
